import { render, staticRenderFns } from "./SelectMask.vue?vue&type=template&id=5f36826a"
import script from "./SelectMask.vue?vue&type=script&lang=js"
export * from "./SelectMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports